export const pdfBundle = {
  info: {
    usage: { ko: "사용량", en: "Usage", es: "Consumo" },
    leakAmount: { ko: "누수량", en: "Leak Volume", es: "Volumen de fuga" }
  }
}
